export default __webpack_public_path__ + "static/media/AP.5b2db26f.svg";